import type { HistogramChartLegendProps } from '../types/histogram.js';

export const Legend = (props: HistogramChartLegendProps) => null;

Legend['displayName'] = 'HistogramChart.Legend';
